import * as actionTypes from '../actionTypes';
import {
    addCollectionProductsApi,
    checkSlugUrlApi,
    createCollectionApi,
    deleteCollectionApi,
    deleteCollectionProductsApi,
    editCollectionApi,
    getAllCollectionsApi,
    getCollectionBySlugApi,
    getUserCollectionsApi,
    uploadAssetsApi
} from '../../api/apiUrls/collection';

const getCollectionsStart = () => ({type: actionTypes.GET_ALL_COLLECTIONS_START});
const getCollectionsSuccess = (payload) => ({type: actionTypes.GET_ALL_COLLECTIONS_SUCCESS, payload});
const getCollectionsFail = () => ({type: actionTypes.GET_ALL_COLLECTIONS_FAIL});

const getUserCollectionsStart = () => ({type: actionTypes.GET_USER_COLLECTIONS_START});
const getUserCollectionsSuccess = (payload) => ({type: actionTypes.GET_USER_COLLECTIONS_SUCCESS, payload});
const getUserCollectionsFail = () => ({type: actionTypes.GET_USER_COLLECTIONS_FAIL});

const getCollectionStart = () => ({type: actionTypes.GET_COLLECTION_START});
const getCollectionSuccess = (payload) => ({type: actionTypes.GET_COLLECTION_SUCCESS, payload});
const getCollectionFail = (payload) => ({type: actionTypes.GET_COLLECTION_FAIL, payload});

const saveCollectionStart = () => ({type: actionTypes.SAVE_COLLECTION_START});
const saveCollectionSuccess = (payload) => ({type: actionTypes.SAVE_COLLECTION_SUCCESS, payload});
const saveCollectionFail = (payload) => ({type: actionTypes.SAVE_COLLECTION_FAIL, payload});

const uploadAssetStart = () => ({type: actionTypes.UPLOAD_ASSET_START});
const uploadLogoSuccess = (payload) => ({type: actionTypes.UPLOAD_LOGO_SUCCESS, payload});
const uploadBannerSuccess = (payload) => ({type: actionTypes.UPLOAD_BANNER_SUCCESS, payload});
const uploadFeatureSuccess = (payload) => ({type: actionTypes.UPLOAD_FEATURE_SUCCESS, payload});
const uploadAssetFail = (payload) => ({type: actionTypes.UPLOAD_ASSET_FAIL, payload});

const checkSlugStart = () => ({type: actionTypes.CHECK_URL_START});
const checkSlugSuccess = (payload) => ({type: actionTypes.CHECK_URL_SUCCESS, payload});
const checkSlugFail = (payload) => ({type: actionTypes.CHECK_URL_FAIL, payload});

const deleteCollectionStart = () => ({type: actionTypes.DELETE_COLLECTION_START});
const deleteCollectionSuccess = (payload) => ({type: actionTypes.DELETE_COLLECTION_SUCCESS, payload});
const deleteCollectionFail = (payload) => ({type: actionTypes.DELETE_COLLECTION_FAIL, payload});

// Get all collections
const getCollections = (token) => (dispatch) => {
    dispatch(getCollectionsStart());

    return getAllCollectionsApi(token)
        .then(({data}) => {
            dispatch(getCollectionsSuccess(data));
        })
        .catch((error) => {
            dispatch(getCollectionsFail(error));
        });
};

// Get user collections
const getUserCollections = (name) => (dispatch) => {
    dispatch(getUserCollectionsStart());

    return getUserCollectionsApi(name)
        .then(({data}) => {
            dispatch(getUserCollectionsSuccess(data));
        })
        .catch((error) => {
            dispatch(getUserCollectionsFail(error));
        });
}

// Get collection by slug
const getCollection = (slug, page = 1) => (dispatch) => {
    dispatch(getCollectionStart());

    return getCollectionBySlugApi(slug, page)
        .then(({data}) => {
            dispatch(getCollectionSuccess(data));
        })
        .catch((error) => {
            dispatch(getCollectionFail(error));
        });
}

// Create collection
const createCollection = (data, token) => (dispatch) => {
    dispatch(saveCollectionStart());

    return createCollectionApi(data, token)
        .then(({data}) => {
            dispatch(saveCollectionSuccess(data));
            return data;
        }).catch((error) => {
            dispatch(saveCollectionFail(error));
            return error;
        })
}

// Edit collection
const editCollection = (id, data, token) => (dispatch) => {
    dispatch(saveCollectionStart());

    return editCollectionApi(id, data, token)
        .then(({data}) => {
            dispatch(saveCollectionSuccess(data));
            return data;
        }).catch((error) => {
            dispatch(saveCollectionFail(error));
            return error;
        })
}

// Upload assets
const uploadAsset = (type, data, token) => (dispatch) => {
    dispatch(uploadAssetStart());

    return uploadAssetsApi(data, token)
        .then((data) => {
            if (type === 'logo') {
                dispatch(uploadLogoSuccess(data));
            } else if (type === 'banner') {
                dispatch(uploadBannerSuccess(data));
            } else {
                dispatch(uploadFeatureSuccess(data));
            }
            return data.data;
        }).catch((error) => {
            dispatch(uploadAssetFail(error));
        })
}

// Check slug url
const checkSlugUrl = (url, token) => (dispatch) => {
    dispatch(checkSlugStart());

    return checkSlugUrlApi(url, token)
        .then((data) => {
            dispatch(checkSlugSuccess(data))
            return data;
        }).catch((error) => {
            dispatch(checkSlugFail(error));
        })
}

// Delete collection
const deleteCollection = (id, token) => (dispatch) => {
    dispatch(deleteCollectionStart());

    return deleteCollectionApi(id, token)
        .then(({data}) => {
            dispatch(deleteCollectionSuccess(data))
            return data;
        }).catch((error) => {
            dispatch(deleteCollectionFail(error));
            return error;
        })
}

// Add products to collection
const addProducts = (data, token) => (dispatch) => {
    dispatch(deleteCollectionStart());

    return addCollectionProductsApi(data, token)
        .then(({data}) => {
            return data;
        })
        .catch((error) => {
            return error;
        })
}

// Delete product from collection
const deleteProduct = (collectionid, productId, token) => (dispatch) => {
    dispatch(deleteCollectionStart());

    return deleteCollectionProductsApi(collectionid, productId, token)
        .then(({data}) => {
            return data;
        })
        .catch((error) => {
            return error;
        })
}

const collectionsActions = {
    getCollections,
    getUserCollections,
    getCollection,
    createCollection,
    editCollection,
    uploadAsset,
    checkSlugUrl,
    deleteCollection,
    addProducts,
    deleteProduct
};

export default collectionsActions;
